import { render, staticRenderFns } from "./HostingPlayer.vue?vue&type=template&id=3664b41b&scoped=true&lang=html&"
import script from "./HostingPlayer.vue?vue&type=script&lang=js&"
export * from "./HostingPlayer.vue?vue&type=script&lang=js&"
import style0 from "./HostingPlayer.vue?vue&type=style&index=0&id=3664b41b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3664b41b",
  null
  
)

export default component.exports